import { Form } from "@/components/core/forms/form.tsx";
import { useForm } from "react-hook-form";

export default function SampleModal() {
  const form = useForm({
    defaultValues: {
      id: 1
    },
  });

  return (
    <Form {...form}>
      <form className="w-full">
        <div className="flex flex-col w-full">
          <span>This is a modal</span>
        </div>
      </form>
    </Form>
  );
}
